/**
 * FORINT — EGY közös szabály a BEVITELRE (ez a fejléc) és a KIÍRÁSRA (`formatForint`, a fájl
 * végén, külön fejléccel: ott a „0 Ft kontra nincs adat" és az ezres tagolás indoklása).
 *
 * A FELÜLET MINDEN PÉNZ-MEZŐJE — NYOLC, és MIND a nyolc ezen a modulon él [BL-A, 2026-09-14].
 * A felsorolás SZÁNDÉKOSAN teljes, `fájl:sor`-ral: a 4. validátor-kör BLOKKOLÓJA épp az volt, hogy
 * ez a fejléc „minden forint-mezőt" állított, közben a nyolcadik (helyszín havi költsége) `Number()`-en
 * maradt, tehát az állítás HAMIS volt. A létező mezők listája ellenőrizhető:
 *   grep -rniE 'label="[^"]*(ft\)|összeg|díj|bér|költség)' src/components
 *
 *   1. Összeg (Ft) — kifizetési tétel      `CoachPayment/CoachPaymentManagement.tsx` („Tétel" űrlap)
 *   2. Fizetett/Beszedett összeg (Ft)       `EventAttendance.tsx` (asztali tábla + mobil kártya)
 *   3. Óradíj (Ft)                          `UserManagement.tsx` (edző-ág)
 *   4. Magánóra-díj (Ft)                    `UserManagement.tsx` (játékos-ág)
 *   5. Óradíj (HUF)                         `UserProfile.tsx` (saját adatlap, edző)
 *   6. Magánóra-díj (Ft)                    `UserProfileDialog.tsx` (admin által, játékos)
 *   7. Óradíj (Ft)                          `UserProfileDialog.tsx` (admin által, edző)
 *   8. Havi költség (Ft)                    `VenueManagement.tsx` (helyszín)  ← BL-A, 2026-09-14
 *
 * ✅ EZT A NÉVSORT MOSTANTÓL ŐR-TESZT VÉDI: `src/utils/__tests__/moneyFieldWiring.test.ts`.
 * Végigjárja a `components` alatti összes `.tsx`-et, kigyűjti a pénz-szagú címkéket, és PIROSRA
 * fordul, ha egy forint-mező nem ezen a modulon él, ha `type="number"`, vagy ha a fenti névsor
 * elcsúszik a valóságtól. Három negatív próbával igazolva (2026-09-14): a helyszín mezőjét
 * `type="number"`-re visszaírva 2 teszt piros; egy KILENCEDIK pénz-címkét felvéve 4 teszt piros;
 * az import kivételével 1 teszt piros. ⚠️ Új forint-mező esetén MINDKETTŐT vezesd át: ezt a
 * névsort és az őr `EXPECTED_LABELLED` listáját.
 *
 * ⚠️ MI NEM TARTOZIK IDE: ami nem pénz. A kifizetés egyedi tételének „Órák (opcionális)" mezője
 * (`CoachPaymentManagement`) SZÁNDÉKOSAN tizedes (`step: 0.5` — a fél óra valódi eset), és marad
 * `type="number"` + `parseFloat`. A BL-A után a felületen megmaradt `type="number"` mezők
 * (megmérve, `grep -rn '^\s*type="number"' src/components`, 2026-09-14) MIND DARABSZÁM vagy
 * SORREND — egyik sem pénz:
 *   `VenueManagement` „Asztalok száma" · `EventCreateDialog`/`EventEditDialog` „Maximum
 *   résztvevők száma" + „Szükséges asztalok száma" · `TableReservationDialog` „Asztalok száma"
 *   · `PlannedEventDialog` „Maximális Létszám" + „Szükséges Asztalok" · `EventTypeManagement`
 *   „Sorrend" · `CoachPaymentManagement` „Órák (opcionális)".
 * A modul tehát minden FORINT-mezőre egy szabály, de nem minden szám-mezőre.
 *
 * MINDEN MEZŐ VÁZLAT-TARTÓ — ⚠️ ITT KORÁBBAN MÁS ÁLLT [NB-1, 2026-09-14 → JAVÍTVA BL-2b, 2026-09-15].
 * A fejléc 2026-09-15-ig KÉT mező-családot mondott (vázlat-tartó vs. szám-állapotú), és azt is,
 * hogy a szám-állapotú mező kiürülése „nem néma adatvesztés, csak egy extra újragépelés". Ez az
 * állítás a MENTÉSI ÚTRA HAMIS VOLT, mérve (lásd a `isForintInputAccepted` J-3 bekezdését): a
 * félbe-takarított „2." az állapotban `undefined` lett, a mentés ezt küldte ki, és a szerver a
 * TÁROLT összeget/óradíjat NULL-ra írta. Mostantól:
 *   • MEGJELENÍTÉS: mind a nyolc mező NYERS SZÖVEGET (vázlatot) mutat, tehát a félbe-takarított
 *     „2." LÁTSZIK — a jelenléti íven `paymentDrafts`, a helyszín-űrlapon maga a
 *     `formData.monthlyCost`, a három felhasználói űrlapon egy külön, CSAK MEGJELENÍTÉSRE
 *     szolgáló `forintDrafts` állapot;
 *   • MENTENDŐ ÉRTÉK: változatlanul `number | undefined` (a helyszínnél nyers szöveg), tehát a
 *     mentetlen-változás ALAPVONALÁNAK alakja NEM változott — pont ezt a kockázatot nevezte meg
 *     az NB-1 döntés, ezért a vázlat szándékosan a megjelenítés mellé került, nem a helyére;
 *   • MENTÉS: a köztes vázlatból NEM mehet ki mentés — lásd `isUnfinishedForintDraft`.
 *
 * MIÉRT EGY HELYEN [BL-2 + N-8, 2026-09-14]: a felületen HAT külön, saját parser élt ugyanerre a
 * feladatra (`Number(...)`, `parseFloat(...)`, majd egy hetedik regex a jelenléti íven), és
 * MINDEGYIK ugyanabba a néma, EZERSZERES hibába futott. Mérés a valódi felületen (Chromium hu-HU
 * → :3000 → backend :5229 → DB, valódi leütésekkel, `Mentés`-sel, majd `GET
 * /api/attendance/event/{id}`-ből visszaolvasva):
 *
 *     gépelt "2.800" -> a MEZŐBEN: "2.800" -> a SZERVEREN: 2.8 Ft     ← EZERSZERES tévedés, NÉMÁN
 *     gépelt "2,800" -> a MEZŐBEN: "2,800" -> a SZERVEREN: 2.8 Ft     ← EZERSZERES tévedés, NÉMÁN
 *     gépelt "2 800" -> a MEZŐBEN: "2800"  -> a SZERVEREN: 2800 Ft
 *     gépelt "2800"  -> a MEZŐBEN: "2800"  -> a SZERVEREN: 2800 Ft
 *
 * Magyar írásmódban a `2.800` és a `2,800` egyaránt KÉTEZER-NYOLCSZÁZAT jelent (a pont/vessző
 * ezres-elválasztó), a `Number('2.800')` viszont 2.8-at, a `parseFloat('2.800')` szintén 2.8-at ad.
 * A kár kettős: a játékos egyenlege ~2797 Ft-tal hibás, ÉS a `CoachPaymentController` a beszedett
 * összeget LEVONJA az edző kifizetéséből, tehát a klub ~2797 Ft-tal TÖBBET fizet az edzőnek.
 *
 * ⚠️ FOGALOM-ÜTKÖZÉS A `formDirty.ts`-SZEL, KIMONDVA [NB-6, 2026-09-14]: a `formDirty.ts`
 * `numericValue`-ja a `,`-t TIZEDES-jelnek veszi (`Number(trimmed.replace(',', '.'))`), tehát OTT a
 * `"2,800"` → 2.8. UGYANAZ a karakter, két ellentétes jelentés — de a két szabály KÜLÖN célra
 * való: a `formDirty` CSAK ÖSSZEVETÉSRE használja („piszkos-e az űrlap?"), és SOHA nem állít elő
 * mentendő összeget; a pénz-BEVITEL egyetlen értelmezője ez a modul. A pénz-mezőkben 2026-09-14
 * óta vesszős szöveg nem is tud állni, a megmaradt `type="number"` mezők pedig darabszámok és a
 * SZÁNDÉKOSAN tizedes „Órák" — ott a tizedes-vessző értelmezés a helyes. A részletes indoklás a
 * `formDirty.ts` `numericValue`-jának kommentjében áll (mindkét helyen kimondva, hogy a következő
 * olvasó ne az egyiket alkalmazza a másik helyén).
 *
 * A SZABÁLY: a pénz-mező tartalma MINDIG csak számjegy — EGÉSZ FORINT, tizedes nélkül.
 *
 * MIÉRT szabad tizedes NÉLKÜL — MÉRVE, de CSAK a dev/E2E adatbázison (`PinyoTestDb`):
 *     att_total            = 224   (nem-null EventAttendance.PaymentAmount)
 *     att_fractional       = 0     (ebből tizedes törtrésszel)
 *     att_under10_nonzero  = 0     (0 < összeg < 10 Ft — azaz „elgépelt tizedes" nyoma)
 *     hourly_fractional    = 0     (Users.HourlyRate)
 *     plf_fractional       = 0     (Users.PrivateLessonFee)
 * Nulla tizedes összeg és nulla 10 Ft alatti összeg. A FORINTNAK 1999 ÓTA NINCS ALEGYSÉGE (a
 * fillért kivonták), a klub készpénzt szed be egész forintban, és a felület maga is ezt mondja
 * („0-nál nagyobb egész szám" — Óradíj mező súgója).
 *
 * 🔴 AMI NINCS MEGMÉRVE: az ÉLES adatbázis. Az éles DB olvasását a jogosultsági szabály itt nem
 * engedte, tehát erre a modul NEM támaszkodhat — és pont az a hiba lényege, hogy élesben BE
 * LEHETETT gépelni a `2.800`-at, tehát élesben LEHET tizedes sor. Ezért a modul úgy van
 * megírva, hogy egy MEGLÉVŐ tizedes érték is JAVÍTHATÓ legyen (lásd `isForintInputAccepted`):
 * a tizedes BEVITEL zárva van, a tizedes TAKARÍTÁSA nem.
 *
 * ⚠️ EZÉRT NE „JAVÍTSD VISSZA" a tizedes-elfogadást. Ha valaha valódi igény lesz tizedesre, az
 * ELŐBB döntés (és adat-migráció) kérdése: addig minden tizedes-jel elfogadása azt jelenti, hogy a
 * magyar írásmód szerint gépelő felhasználó ezredannyit ment el, ANÉLKÜL, hogy bármi jelezné.
 *
 * A nem-számjegy leütést VISSZA IS UTASÍTJUK (nem némán átalakítjuk): így a `2.800` gépelésekor a
 * pont nem kerül be, a mező `2800`-at mutat, és a felhasználó LÁTJA, mi fog elmenni. Ez ugyanaz a
 * viselkedés, ami a szóközre eddig is érvényes volt (`2 800` → `2800`).
 */

/**
 * A pénz-mezőbe ELFOGADOTT szöveg alakja: csak számjegy, vagy üres (= „nincs megadva").
 * Előjel NINCS: negatív összeget a szerver `[Range(0, …)]`-e 400-cal dob vissza, a magyar indoklás
 * viszont a válasz `errors` mezőjében utazik, amit a felület ma nem mutat meg — a jelenléti ív
 * BULK mentése így EGY mező miatt a TELJES névsor munkáját elvesztette (mérve: `paymentAmount:-100`
 * → 400, `{"errors":{"Attendances[0].PaymentAmount":["A fizetett összeg 0 és 1 000 000 között
 * lehet."]}}`, a felületen csak „Nem sikerült menteni a jelenlétet (HTTP 400)").
 */
export const FORINT_INPUT_SHAPE = /^\d*$/;

/**
 * Elfogadható-e a mezőbe éppen bekerülő szöveg? (Ha nem, a leütést EL SEM TÁROLJUK, tehát a mező
 * a korábbi tartalmát mutatja tovább — a kontrollált React-mezőt a React maga állítja vissza.)
 *
 * Beillesztésre (paste) is ez a szabály: a `2 800 Ft` alakú beillesztés NEM kerül be (semmi nem
 * változik a mezőben), mert a csendes átalakításnál többet ér, ha a felhasználó látja, hogy a
 * bevitele nem történt meg.
 *
 * ✅ TUDATOS DÖNTÉS, nem kifelejtett eset [NB-5, 2026-09-14]. MÉRVE: a beillesztés NÉMA NO-OP — a
 * mező a KORÁBBI tartalmát mutatja tovább, tehát NEM adatvesztés (őr-teszt:
 * `VenueManagement.money.test.tsx`, „a szöveges BEILLESZTÉS nem változtatja meg a mezőt").
 * MIÉRT NEM szűrjük ki a számjegyeket a beillesztett szövegből: a „2 800 Ft"-ból kiszűrt `2800`
 * HELYES lenne, a „kb. 2-3000 Ft"-ból kiszűrt `23000` viszont KITALÁLT szám — és a kettő a
 * mezőben UGYANÚGY nézne ki. Egy pénz-mezőn a némán kitalált szám a rosszabb kimenet, mint a
 * láthatóan meg nem történt bevitel.
 */
export function isForintInputShape(value: string): boolean {
  return FORINT_INPUT_SHAPE.test(value);
}

/**
 * Elfogadható-e a mező ÚJ tartalma, a MOSTANI tartalom ismeretében? Ezt kell a mezők
 * `onChange`-ében használni (a puszta `isForintInputShape` helyett).
 *
 * MIÉRT KELL A MOSTANI ÉRTÉK IS [J-3, 2026-09-14]: ha egy RÉGI, már eltárolt sor tizedes összeget
 * tartalmaz (élesben ez lehetséges — lásd a fejléc „AMI NINCS MEGMÉRVE" bekezdését), akkor a mező
 * kiinduló tartalma maga is szabálytalan (`"2.8"`). A szigorú szűrő mellett MINDEN leütést
 * elutasítottunk volna rajta, tehát a mező „halottnak" tűnt volna — pont azokon a sorokon, amiket
 * javítani KELL. MÉRVE (a szigorú szabállyal, a javítás előtt) — EZ A FÜGGVÉNY viselkedése:
 *
 *     a DB-ben 2.8 -> a mező "2.8", alak-érvényes? false
 *      backspace 1x        -> "2."   ELUTASÍTVA -> a mező "2.8" marad
 *      új számjegy a végén -> "2.85" ELUTASÍTVA -> a mező "2.8" marad
 *      backspace 2x        -> "2"    ELFOGADVA
 *      select-all + törlés -> ""     ELFOGADVA
 *
 * A SZABÁLY: elfogadjuk, ha az új érték számjegy-alakú, VAGY ha a mostani érték NEM számjegy-alakú
 * ÉS az új érték RÖVIDEBB — azaz a felhasználó éppen TAKARÍTJA a régi, tizedes tartalmat. A
 * tizedes BEVITEL így továbbra is zárva (számjegy-alakú kiindulásból nem lehet tizedest építeni).
 *
 * 🔴 AMIT EZ A FÜGGVÉNY EGYEDÜL NEM TUD MEGOLDANI — a 2026-09-15-i BLOKKOLÓ [BL-2b]:
 * az elfogadott takarító leütés (`"2."`) olyan tartalom, amit a `parseForintInput` NEM tud
 * képviselni (`undefined`). Amíg a mentés ezt az `undefined`-ot küldte ki, a szerver a TÁROLT
 * értéket NULL-ra írta — tehát a takarítás FÉLBEHAGYÁSA TÖRÖLTE a klub adatát, miközben a
 * felület számot mutatott vagy üres mezőt. MÉRVE (komponens-tesztek, 2026-09-15):
 *
 *   jelenléti ív:      DB 2.8 -> mező "2.8" -> 1 backspace -> mező "2."  -> Mentés
 *                      -> a bulk kérésből a `paymentAmount` KIMARADT -> `AttendanceController.cs:412`
 *                         `existing.PaymentAmount = record.PaymentAmount` -> NULL
 *   edző óradíja:      DB 2.8 -> mező "2.8" -> 1 backspace -> mező ÜRES  -> Mentés
 *                      -> a PUT-ból a `hourlyRate` KIMARADT -> `UserProfileController.cs:404`
 *                         `user.HourlyRate = dto.HourlyRate` -> NULL (és minden kifizetés díj nélkül fut)
 *
 * A JAVÍTÁS KÉT LÉPÉSE (mindkettő kell):
 *   (1) a köztes vázlat LÁTSZIK — a három felhasználói űrlap is nyers szöveget jelenít meg
 *       (`forintDrafts`), tehát a „2." nem tűnik el a felhasználó szeme elől;
 *   (2) a MENTÉS MEGÁLL, ha bármelyik vázlat köztes (`isUnfinishedForintDraft`), és MEGNEVEZI,
 *       melyik soron/mezőn — a `MAX_ATTENDANCE_PAYMENT` őr mintájára.
 *
 * MIÉRT NEM a Venue-féle TARTALÉK-ÁG (`parsed ?? legacy`) ezeken a mezőkön: ott a mező állapota
 * MAGA a betöltött nyers szöveg, tehát az ÉRINTETLEN „22000.5" ugyanúgy szabálytalan alakú, mint
 * a félbe-takarított „22000." — a kettő nem különböztethető meg, ezért ott BLOKKOLNI nem lehet
 * (az érintetlen mentés is elbukna), és a tartalék a helyes megoldás. A többi hét mezőnél a
 * vázlat CSAK felhasználói leütésre jön létre, tehát az „érintetlen" és a „félbehagyott" eset
 * megkülönböztethető — ott a blokkolás a jobb: a tartalék NÉMÁN a régi számot mentené, miközben a
 * mező mást mutat.
 *
 * A SZÁNDÉKOS TÖRLÉS MEGMARAD: az üres mező (`""`) SZÁMJEGY-ALAKÚ, tehát nem köztes vázlat — a
 * „nincs megadva" mentése változatlanul működik minden mezőn.
 */
export function isForintInputAccepted(next: string, current: string): boolean {
  if (isForintInputShape(next)) return true;
  return !isForintInputShape(current) && next.length < current.length;
}

/**
 * KÖZTES („félbe-takarított") vázlat-e a mezőbe gépelt szöveg? [BL-2b, 2026-09-15]
 *
 * Igen, ha a felhasználó gépelt bele (`typeof draft === 'string'`), és a tartalom NEM
 * számjegy-alakú — azaz a `parseForintInput` „nincs megadva"-t adna rá, miközben a felhasználó
 * nem törölni akart, hanem egy RÉGI, tizedes értéket takarít (`"2.8"` → `"2."`).
 *
 * ⚠️ `typeof draft === 'string'`, NEM `!!draft`: a `""` (szándékos törlés) SZÁMJEGY-ALAKÚ, tehát
 * amúgy sem köztes — a `!!` viszont a „nincs vázlat" (`undefined`) esetet mosná össze vele.
 *
 * Erre a függvényre a MENTÉS őre épül: köztes vázlatból nem mehet ki mentés, mert a kiküldött
 * `undefined` a szerveren a TÁROLT összeget NULL-ra írja (a mérést lásd `isForintInputAccepted`).
 */
export function isUnfinishedForintDraft(draft: string | null | undefined): boolean {
  return typeof draft === 'string' && !isForintInputShape(draft);
}

/**
 * A mentés megállításának MAGYAR mondata, a hibás sor/mező MEGNEVEZÉSÉVEL.
 *
 * MIÉRT NÉVVEL: a jelenléti ív mentése BATCH (a teljes névsor egy kérésben), a felhasználói
 * űrlapokon pedig több pénz-mező is van — név nélkül a felhasználó nem tudná, hol álljon meg.
 * Ugyanaz a minta, mint a „Túl nagy összeg: <név>" őrnél (`MAX_ATTENDANCE_PAYMENT`).
 *
 * @param subject a sor játékosának neve, vagy a mező címkéje („Óradíj (Ft)")
 */
export function unfinishedForintMessage(subject: string): string {
  return `Fejezd be az összeg javítását: ${subject} — a mezőben csak számjegy állhat.`;
}

/**
 * A mezőbe gépelt szöveg → mentendő EGÉSZ forint-összeg.
 *
 * Üres mező → `undefined` („nincs megadva"), SZÁNDÉKOSAN nem 0: a nulla forint érdemi érték
 * („ingyen"), az üres mező pedig azt jelenti, hogy nincs megadva — a mobil app is így teszi.
 *
 * Bármi, ami nem tiszta számjegy-sorozat → `undefined`. Ez a MÁSODIK védelmi vonal: a mező
 * alak-szűrője (`isForintInputShape`) miatt ilyen tartalom nem is tud a mezőben lenni, de ha egy
 * jövőbeli hívó kihagyná a szűrőt, akkor is inkább „nincs megadva" menjen ki, mint az ezredannyi.
 * `'2.800'`, `'2,800'`, `'1e3'`, `'0x10'`, `'-100'`, `'1.234.567'` → mind `undefined`.
 */
export function parseForintInput(value: string): number | undefined {
  if (value === '' || !isForintInputShape(value)) return undefined;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/**
 * A SZÁM-állapot → a mezőben MEGJELENÍTETT szöveg. A `null`/`undefined` üres mező.
 *
 * ⚠️ `?? ''`, NEM `|| ''`: a `0 || ''` ÜRES mezőt adna, miközben az állapotban 0 van — a
 * „láthatatlan nulla" egy ÉRINTETLEN űrlapon is „mentetlen módosítást" jelentene [N-12].
 */
export function forintFieldValue(amount: number | null | undefined): string {
  return amount == null ? '' : String(amount);
}

/**
 * A jelenléti ív BULK mentésének szerver-oldali felső korlátja
 * (`AttendanceDto`: `[Range(0.0, 1_000_000.0, ErrorMessage = "A fizetett összeg 0 és 1 000 000
 * között lehet.")]`, `backend/PinyoApi/DTOs/AttendanceDto.cs:37`).
 *
 * ⚠️ KOMMENT-JAVÍTÁS [2026-09-14, NB7 lelet]: itt korábban `[Range(0, 1000000)]` jelölés állt,
 * és az az INDOKLÁS, hogy „a felület csak egy technikai HTTP 400-at ír ki". Az ÉRTÉK azóta is
 * ugyanaz (mérve), de a JELÖLÉS elavult volt, az indoklás pedig MA MÁR NEM IGAZ: 2026-09-14 óta
 * a szerver 400-as válasza magyar `message`-t is ad (`Program.cs`
 * `InvalidModelStateResponseFactory`), és mindkét kliens ki is olvassa az `errors` szótárat
 * (`utils/apiErrors.ts`). A felhasználó tehát MA MÁR MEGKAPJA a szerver magyar indoklását.
 *
 * MIÉRT MARAD MÉGIS A KLIENS-OLDALI ELLENŐRZÉS: nem a hibaszöveg miatt, hanem mert a mentés
 * BATCH művelet — egyetlen túl nagy összeg a TELJES névsor munkáját visszadobná. Itt viszont
 * meg tudjuk NEVEZNI, KINEK a sora a hibás, még mentés előtt. Ez az érv a szerver-oldali
 * javítás után is érvényes.
 */
export const MAX_ATTENDANCE_PAYMENT = 1000000;

/**
 * A KIFIZETÉSI TÉTEL („Összeg (Ft)", `CoachPaymentManagement`) szerver-oldali felső korlátja
 * (`CustomPaymentItemDto`: `[Range(0.0, 1_000_000.0, ErrorMessage = "Az összeg 0 és 1 000 000 Ft
 * között lehet.")]`, `backend/PinyoApi/DTOs/CoachPaymentDto.cs:101`).
 *
 * ⚠️ KOMMENT-JAVÍTÁS [2026-09-14, NB7 lelet]: a jelölés korábban `[Range(0, 1000000)]` volt —
 * az ÉRTÉK azóta is ugyanaz (mérve), csak a jelölés elavult. Azt is pontosítottuk, hogy a magyar
 * indoklás MA MÁR kijut a felhasználóhoz (lásd `MAX_ATTENDANCE_PAYMENT` fölött).
 *
 * MIÉRT KELL KLIENS-OLDALON IS [NB-3, 2026-09-14]: a kifizetés-létrehozás BATCH művelet — a
 * kiválasztott edzések ÉS az összes egyedi tétel EGY kérésben megy (`createPayment`). Ha egyetlen
 * tétel összege túl nagy, a szerver 400-at ad, és az ADMIN az egész összeállított kifizetést
 * elveszíti — akkor is, ha a hibaszöveg ma már magyarul megjön. Itt viszont a TÉTEL FELVÉTELEKOR
 * állunk meg, amikor még semmi nem veszik el. A jelenléti ív ugyanezt az őrt már kapta
 * (`MAX_ATTENDANCE_PAYMENT`); a `git diff` szerint innen a korábbi `inputProps={{ min: 0 }}`
 * PÓTLÁS NÉLKÜL tűnt el (a `min: 0` elvesztése ártalmatlan — a számjegy-szűrő nem is engedi be
 * a mínuszt —, a hiányzó FELSŐ korlát viszont nem).
 *
 * HOL ÁLL AZ ŐR: a TÉTEL FELVÉTELEKOR (`handleAddCustomItem`), NEM a batch előtt — a listába
 * kizárólag a felvétel tesz elemet (tétel-szerkesztés nincs), tehát ott a visszajelzés azonnali,
 * és túl nagy tétel el sem jut a kérésig. A jelenléti íven az őr azért van a MENTÉSBEN, mert ott a
 * sorok a SZERVERRŐL töltődnek, tehát nincs egyetlen „felvételi" pont.
 */
export const MAX_CUSTOM_ITEM_AMOUNT = 1000000;

/**
 * ══════════════════════════════════════════════════════════════════════════════════════════
 * FORINT-KIÍRÁS — EGY közös alak minden MEGJELENÍTETT összegre [B-W3, 2026-09-16]
 * ══════════════════════════════════════════════════════════════════════════════════════════
 *
 * ⚠️ EZ A MODUL EDDIG CSAK A BEVITELT SZABÁLYOZTA. A KIÍRÁS mindenhol kézzel készült, és a
 * kimutatásokban KÉT valódi hibát okozott:
 *
 *  1. A NULLA FORINT „–"-KÉNT JELENT MEG. A minta `user.totalCollected ? `${…} Ft` : '-'` volt
 *     (`Reports.tsx`, 12 helyen). A 0 JavaScriptben hamis, tehát a „nem szedett be semmit"
 *     ugyanúgy „–" lett, mint a „nincs erről adatunk". Egy pénzügyi kimutatásban ez a két
 *     állítás NEM ugyanaz: az egyik ellenőrizhető tény (0 Ft), a másik hiányzó adat. A klub
 *     ebből nem tudta megmondani, hogy egy edző tényleg nem szedett-e be semmit, vagy a
 *     kimutatás nem tud róla.
 *
 *  2. A MILLIÓS ÖSSZEGEK TAGOLÁS NÉLKÜL, EGYBEN jelentek meg („2586900 Ft"). Hét számjegyet
 *     ránézésre senki nem olvas el helyesen — és épp ezeken a számokon (edzői kifizetés,
 *     beszedés) múlik egy utalás.
 *
 * A HELYES ALAK: `null`/`undefined` → „–" (nincs adat), `0` → „0 Ft" (van adat, és nulla),
 * minden más → magyar ezres tagolással.
 *
 * ⚠️ MIÉRT VAN KÉZI TAGOLÁS-NORMALIZÁLÁS: a `toLocaleString('hu-HU')` a csoport-elválasztóra az
 * ICU-verziótól függően ad `U+00A0`-t (nem törő szóköz) vagy `U+202F`-et (keskeny nem törő
 * szóköz). Két KÜLÖNBÖZŐ karakter ugyanarra a célra azt jelenti, hogy egy szó szerinti
 * összehasonlítás (teszt, E2E, export-összevetés) a futtató környezetétől függően bukna el.
 * Ezért MINDEN elválasztót EGYETLEN fajtára (`U+00A0`) írunk át, és a „Ft" elé is ilyen kerül:
 * az összeg és a mértékegység így SOHA nem szakad két sorba.
 *
 * ⚠️ A MAGYAR TAGOLÁSI SZABÁLY (mérve, Node ICU + Chrome): NÉGYJEGYŰ számot a `hu-HU` NEM
 * tagol („1000 Ft"), ötjegyűtől tagol („15 317 Ft"). Ez SZÁNDÉKOS — ez a helyes magyar
 * helyesírás —, tehát ne „javítsa" senki egyenletes tagolásra.
 *
 * 🔴 AKI ÚJ PÉNZ-KIÍRÁST ÍR, EZT HASZNÁLJA. Két formázó két helyen = két különböző alak
 * ugyanarra az összegre; pontosan ezt a szétcsúszást szüntette meg ez a segéd (a
 * `EventAttendance.tsx` saját `formatHuf`-ja is erre mutat).
 */

/** Amit a felhasználó akkor lát, ha az adat NINCS MEG (nem az, hogy nulla). */
export const NO_AMOUNT_TEXT = '-';

/** A tagolásra és a „Ft" elé HASZNÁLT, EGYETLEN elválasztó: nem törő szóköz. */
const FORINT_GROUP_SEPARATOR = '\u00a0';

/**
 * Egy összeg MAGYAR, tagolt alakja mértékegység NÉLKÜL (pl. `15\u00a0317`).
 * Külön exportált, mert néhány mondat a „Ft" szót ragozva viszi tovább („… Ft-nál több").
 */
export function forintAmountText(value: number): string {
  // A csoport-elválasztó karaktert NEM az ICU-ra bízzuk (lásd a fejléc indoklását): minden
  // szóköz-szerű elválasztót egyetlen fajtára írunk át.
  return value.toLocaleString('hu-HU').replace(/[\s\u00a0\u202f\u2009]/g, FORINT_GROUP_SEPARATOR);
}

/**
 * Egy összeg MEGJELENÍTETT alakja forintban — VAGY „–", ha nincs adat.
 *
 * @param value az összeg; `null`/`undefined`/`NaN` = NINCS ADAT (nem nulla!)
 */
export function formatForint(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return NO_AMOUNT_TEXT;
  return `${forintAmountText(value)}${FORINT_GROUP_SEPARATOR}Ft`;
}
